/*

  Bag.ts

  Bag of tiles component

  Copyright (C) 2024 Miðeind ehf.
  Author: Vilhjalmur Thorsteinsson

  The Creative Commons Attribution-NonCommercial 4.0
  International Public License (CC-BY-NC 4.0) applies to this software.
  For further information, see https://github.com/mideind/Netskrafl

*/

import { ts } from "./i18n";
import { ComponentFunc, m, VnodeChildren } from "./mithril";
import { RACK_SIZE } from "./types";

const BAG_TILES_PER_LINE = 19;

interface IAttributes {
  bag: string;
  newbag: boolean;
}

export const Bag: ComponentFunc<IAttributes> = () => {
  // The bag of tiles

  function tiles(bag: string): VnodeChildren {
    let r: VnodeChildren = [];
    let ix = 0;
    let count = bag.length;
    while (count > 0) {
      // Rows
      let cols: VnodeChildren = [];
      // Columns: max BAG_TILES_PER_LINE tiles per row
      for (let i = 0; i < BAG_TILES_PER_LINE && count > 0; i++) {
        let tile = bag[ix++];
        if (tile == "?")
          // Show wildcard tiles '?' as blanks
          tile = "&nbsp;";
        cols.push(m("td", m.trust(tile)));
        count--;
      }
      r.push(m("tr", cols));
    }
    return r;
  }

  return {
    view: (vnode) => {
      const { bag, newbag } = vnode.attrs;
      let cls = "";
      if (bag.length <= RACK_SIZE)
        cls += ".empty";
      else if (newbag)
        cls += ".new";
      return m(".bag",
        { title: ts("Flísar sem eftir eru") },
        m("table.bag-content" + cls, tiles(bag))
      );
    }
  };
};
